$(function () {
    const $lightBtn = $('button[data-bs-theme-value="light"]');
    const $darkBtn  = $('button[data-bs-theme-value="dark"]');

    // 1) On page load, read localStorage and set initial state:
    const stored = localStorage.getItem(site_key);
    if (stored === 'true') {
      // previously in "dark" mode
      $('body').addClass('dark-mode');
      $darkBtn
        .addClass('active')
        .attr('aria-pressed', 'true');
      $lightBtn
        .removeClass('active')
        .attr('aria-pressed', 'false');
    } else {
      // default to "light" (or nothing stored yet)
      $('body').removeClass('dark-mode');
      $lightBtn
        .addClass('active')
        .attr('aria-pressed', 'true');
      $darkBtn
        .removeClass('active')
        .attr('aria-pressed', 'false');
    }

    // 2) When either "Light" or "Dark" is clicked:
    $('button[data-bs-theme-value]').on('click', function () {
      const choice = $(this).data('bs-theme-value');

      if (choice === 'dark') {
        // turn ON dark mode
        $('body').addClass('dark-mode');
        localStorage.setItem(site_key, 'true');

        $darkBtn
          .addClass('active')
          .attr('aria-pressed', 'true');
        $lightBtn
          .removeClass('active')
          .attr('aria-pressed', 'false');
      } else {
        // choice === 'light' → turn OFF dark mode
        $('body').removeClass('dark-mode');
        localStorage.setItem(site_key, 'false');

        $lightBtn
          .addClass('active')
          .attr('aria-pressed', 'true');
        $darkBtn
          .removeClass('active')
          .attr('aria-pressed', 'false');
      }
    });
  });


// WEBPACK FOOTER //
// ./resources/assets/js/modules/darkmode.js